import Vue from "vue";

const initial = {
  pageSize: 10,
  current: 1,
  total: 0
};
const MyTable = Vue.component("my-table", {
  render() {
    const on = {
      ...this.$listeners
    };
    const props = { ...this.tableConfig, ...this.$props, ...this.$attrs };
    const table = (
      <a-table props={props}  scopedSlots={this.$scopedSlots} on={on}   />
    );
    return (<div> {table} </div>);
  },
  props: {

    rowKey: {
      type: String,
      default: "id"
    },
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    current: {
      type: Number,
      default: 1
    },
    dataSource: {
      type: Array,
      default: () => ([])
    },
    columns: {
      type: Array,
      default: () => ([])
    },
    // currentPageNo: {
    //   type: Number,
    //   default: 1
    // }
  },
  data() {
    return {
      tableConfig: {
        // pagination: {
        //   total: 0,
        //   ...initial
        // },
        dataSource: [],
        rowKey: "accountId",
        loading: false
      },
    };
  },
  methods: {
    handleTableChange(pagination = {}) {
      this.$emit("change", pagination);
    }
  }
});
export default MyTable;
